import { Outlet, useLocation } from 'react-router-dom'
import { Topbar } from './Topbar'
import { AboutButton } from '@versports/ui'
import { AppNavBar } from './AppNavBar'
import { ImpersonationBanner } from './ImpersonationBanner'
import { useAuth } from '../auth/AuthContext'
import { isClubless } from '../auth/postLoginRoute'

/**
 * Root layout for every route in the SPA. Sticky top bar + main + floating
 * "Acerca de" button + bottom NavBar (global navigation: VR / Data /
 * Club / Tablet / Guía / Admin).
 *
 * The about button + nav-bar are global (see CLAUDE.md): every route
 * renders them automatically. `pb-24` keeps the bottom nav from covering
 * the last lines of content. `AppNavBar` renders nothing for an anonymous
 * visitor except on the public setup guide (/guia), so the about button only climbs above
 * the bar (`navOffset`) under the same condition the bar uses to show up.
 */
export function AppShell() {
  const { user } = useAuth()
  // Misma condición que `AppNavBar` para mostrarse — incluida la cuenta sin
  // club, que no tiene barra (mg, 2026-09-09): sin esto el botón "Acerca de"
  // quedaba levantado sobre una barra que no está.
  const { pathname } = useLocation()
  const hasNav = user ? !isClubless(user) : pathname === '/guia'
  return (
    <div className="flex min-h-screen flex-col">
      <ImpersonationBanner />
      <Topbar />
      <main className="flex-1 pb-24">
        <Outlet />
      </main>
      <AboutButton navOffset={hasNav} />
      <AppNavBar />
    </div>
  )
}
